module.exports = __webpack_public_path__ + "static/Group 6458-5c8dcaa6942b8c2735b06ade2d2d5730.png";